<template>
    <span v-if="call.successful" class="text-success">
    <span class="label label-pill label-success">
        <i style="font-size: 1.2em" class="zmdi zmdi-phone"></i>
    </span>
    Appel abouti : {{ call.tags.map(tag => tag.name).join(', ') }}
    </span>
    <span v-else class="text-muted">
    <span class="label label-pill label-default">
        <i style="font-size: 1.2em" class="zmdi zmdi-phone-missed"></i>
    </span>
    Appel non abouti
    </span>
</template>


<script>

export default {
    components: {
      
    },
    name: 'timeline-call-widget',
    props: ['call'],
    data () {
      return {
      }
    },
    methods: {

    }
}
</script>




// WEBPACK FOOTER //
// TimelineCallWidget.vue?3192869c